import request from '@/utils/request'

/**
 * 获取文章列表
 * @param {*} query
 * @returns
 */
export function getArticleList (query) {
  return request({
    url: '/website/public/article',
    method: 'get',
    params: query
  })
}

/**
 * 获取文章详细信息
 * @param {*} id
 * @returns
 */
export function getArticle (id) {
  return request({
    url: '/website/public/article/' + id,
    method: 'get'
  })
}

/**
 * 获取企业列表
 * @param {*} query
 * @returns
 */
export function getCompanyList (query) {
  return request({
    url: '/website/public/corporation',
    method: 'get',
    params: query
  })
}

/**
 * 获取企业详细信息
 * @param {*} id
 * @returns
 */
export function getCompany (id) {
  return request({
    url: '/website/public/corporation/' + id,
    method: 'get'
  })
}
